<template>
  <div class="web-box-all">
    <ext-header :select_menu="select_menu"></ext-header>

    <div class="web-home-main">
      <div class="web-home-title">
        <a></a>
        <p>{{title}}<i></i></p>
        <a></a>
      </div>
      <div class="web-home-activity" v-if="select_id==1">
        <div v-for="(vo,index) in list" :key="index" class="web-home-activity-list" @click="get_activity_list(vo.id)">
          <img src="@/assets/avc_load.png" v-real-img="web_url+vo.image"/>
        </div>
      </div>
      <div class="web-home-activity" v-else>
        <div v-for="(vo,index) in list" :key="index" class="web-home-product-list" @click="get_activity_list(vo.id)">
          <img src="@/assets/avc_load.png" v-real-img="web_url+vo.image"/>
        </div>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/home'
import ExtFooter from '@/components/footer/home'
import {getUserId, ajax, Encrypt, webUrl} from '@/utils/extend'

export default {
  name: 'test',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter
  },
  data () {
    return {
      title: '测试',
      select_menu: 0,
      select_id: 0,
      web_url: webUrl(),
      list: []
    }
  },
  mounted () {
    var params = this.$route.query

    if (params.classid) {
      this.select_menu = 'classid' + params.classid
      this.select_id = params.classid
    } else {
      this.select_menu = 'classid1'
      this.select_id = 1
    }

    if (params.classid === '1') {
      this.title = '促销活动'
    } else {
      this.title = '产品分区'
    }

    this.load_data(params.classid)
  },
  methods: {
    get_activity_list (id) {
      this.$router.push({path: '/activity/activity_show', query: {v: Encrypt(id)}})
    },
    load_data (classid) {
      var that = this
      that.list = []
      if (classid === '1') {
        ajax({
          url: '/store/home/home_activity_json',
          method: 'post',
          data: {
            uid: getUserId()
          }
        }, function (ret) {
          if (ret && ret.code === 'success') {
            that.list = ret.data
          } else {
            that.list = []
          }
        })
      } else {
        ajax({
          url: '/store/home/home_product_json',
          method: 'post',
          data: {
            uid: getUserId()
          }
        }, function (ret) {
          if (ret && ret.code === 'success') {
            that.list = ret.data
          } else {
            that.list = []
          }
        })
      }
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1200px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:12px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

  .web-home-activity { width:100%; height:auto; display: flex;  flex-flow:row; justify-content:space-between; align-content:flex-start; flex-wrap:wrap;}
    .web-home-activity-list{ width:590px; min-height:258px; cursor: pointer; margin-top:15px; position: relative; flex-wrap:wrap; align-content:flex-start;}
    .web-home-activity-list img { width:590px; min-height:218px; object-fit: cover;}
    .web-home-activity-list-p { width:590px; height:40px; position: absolute; font-weight: bold; padding:0px 15px; background: rgba(0,0,0,0.3); left:0px; bottom:-15px; line-height: 40px; font-size:14px; color:#ffffff; }
    .web-home-activity-list p { width:590px; height:37px; margin-top:16px; font-weight: bold; line-height: 27px; font-size:16px; color:#333333; }

    .web-home-product-list{ width:290px; min-height:258px; cursor: pointer; margin-top:15px; position: relative; flex-wrap:wrap; align-content:flex-start;}
    .web-home-product-list img { width:290px; min-height:218px; object-fit: cover;}
    .web-home-product-list-p { width:290px; height:40px; position: absolute; font-weight: bold; padding:0px 15px; background: rgba(0,0,0,0.3); left:0px; bottom:-15px; line-height: 40px; font-size:14px; color:#ffffff; }
    .web-home-product-list p { width:290px; height:37px; margin-top:16px; font-weight: bold; line-height: 27px; font-size:16px; color:#333333; }

</style>



// WEBPACK FOOTER //
// src/pages/activity/zone_activity_goods.vue